import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {useActionItem, useActionItemAction} from 'helpers/hooks/action';
import {wrapChartComponent} from 'helpers/wrapper';
import utils from 'helpers/utils';
import StyledActionPie from 'components/molecules/Charts/ActionPie/ActionPie.styles';
import {Pie} from 'recharts';

const ActionPie = React.forwardRef((props, ref) => {
  const {
    action,
    onClick,
    tabIndex,
    activeShape,
    ...innerProps
  } = useComponentProps({
    tabIndex: -1,
    ...props
  }, 'ActionPie', {
    static: ['clickable']
  });

  const itm = useActionItem(action);
  const handleActionClick = useActionItemAction(itm?.onClick, onClick);
  const clickable = Boolean(handleActionClick);

  const renderActiveShape = (props) => {
    return activeShape?.({
      onClick: clickable ? (e) => {
        handleActionClick?.(e, props, props.value - 1);
      } : null,
      ...props
    });
  }

  innerProps.className = utils.flattenClassName(innerProps.className, {
    clickable: clickable
  });

  return <StyledActionPie ref={ref} {...innerProps}
                          rootTabIndex={tabIndex}
                          onClick={clickable ? (data, index, e) => {
                            handleActionClick?.(e, data, index);
                          } : null}
                          activeShape={activeShape ? renderActiveShape : null} />
});

ActionPie.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  action: PropTypes.object,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number
};

export default wrapChartComponent(ActionPie, Pie);
